import React, { Fragment } from 'react';

import MetaHelmet from '../../AppHelmet/MetaHelmet';
import AppointmentHeader from '../Components/AppointmentHeader';
import HealthInformationProviderForm from './HealthInformationProviderForm';

import { usePageView } from '../../../hocs/usePageView';
import useNavigateToPreviousPage from '../hooks/useNavigateToPreviousPage';
import { IDS } from '../../../constants/ids';
import { submitForm } from '../../../utils/submitForm';

function AppointmentHealthInformationProvider() {
  usePageView('Get Care | Health Information');

  const { navigateToPrevPage } = useNavigateToPreviousPage();

  const handleNavigateToPrevPage = () => {
    const form = document.forms[IDS.PCP_QUESTIONS_WITH_EXTRA_FIELDS_FORM];

    if (!form) {
      navigateToPrevPage();
      return;
    }

    const onSubmitPreventReload = e => {
      e.preventDefault();
      navigateToPrevPage();
    };

    form.addEventListener('submit', onSubmitPreventReload, { once: true });

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      submitForm(form);
    }
  };

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.health" />
      <AppointmentHeader
        title="profile.section.health"
        handleBack={handleNavigateToPrevPage}
      />
      <HealthInformationProviderForm />
    </Fragment>
  );
}

export default AppointmentHealthInformationProvider;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentHealthInformationProvider/index.jsx